/*
  {% render 'product-quantity-selector', product: product %}
*/

const initQuantityInputs = (container = document.querySelector('[data-product-main]')) => {
  if (!container) return;
  const quantitySelectors = container.querySelectorAll('[data-quantity-selector]');

  if (!quantitySelectors.length) return;

  const changeInput = (qtyInput, value, selector) => {
    const maxQty = +selector.getAttribute('data-max-quantity');
    const currentValue = +qtyInput.value || 1;
    if (maxQty && currentValue >= maxQty && value > 0) return;
    const newValue = currentValue + value;
    if (newValue >= 1) {
      // Enable input temporarily to ensure value updates properly
      const wasDisabled = qtyInput.disabled;
      if (wasDisabled) {
        qtyInput.disabled = false;
      }
      qtyInput.value = String(newValue);
      // Trigger events to ensure value is recognized
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      // Keep it enabled if buttons are enabled (product is available)
      const decBtn = selector.querySelector('[data-quantity-dec]');
      const incBtn = selector.querySelector('[data-quantity-inc]');
      if (!decBtn?.disabled && !incBtn?.disabled) {
        qtyInput.disabled = false;
      } else if (wasDisabled) {
        qtyInput.disabled = true;
      }
    }
  };

  quantitySelectors.forEach(selector => {
    const qtyInput = selector.querySelector('[data-quantity-input]');
    if (!qtyInput) return;

    qtyInput.addEventListener('change', () => changeInput(qtyInput, 0, selector));
    selector.addEventListener('click', (evt) => {
      const decBtn = evt.target.closest('[data-quantity-dec]');
      const incBtn = evt.target.closest('[data-quantity-inc]');
      if (decBtn && +qtyInput.value > 1) {
        changeInput(qtyInput, -1, selector);
      }
      if (incBtn) {
        changeInput(qtyInput, +1, selector);
      }
    });
  });
};

export default initQuantityInputs;
